// extracted by mini-css-extract-plugin
export var modal = "_ic-0";